/* eslint-disable jsx-a11y/label-has-associated-control */
import { useId, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import VTButton, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { selectAddToDictPanel } from "slices/discovery/selectors";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import {
  BLANK_CATEGORY_NAME_ERROR,
  CATEGORY_NAME_DUPLICATE_ERROR,
} from "constants/discovery";
import IconWithTooltip from "components/IconWithTooltip";
import { ReactComponent as ErrorIcon } from "icons/dictionary/info-error.svg";
import { createNewCategory } from "slices/discovery/actions/actionButtons";

const CreateNewCategoryModal = ({ insertAt }) => {
  const dispatch = useDispatch();
  const nameId = useId();
  const descriptionId = useId();

  const [name, setName] = useState("");
  const [wasEdited, setWasEdited] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [description, setDescription] = useState("");
  const {
    dictionary: { categories },
  } = useSelector(selectAddToDictPanel);

  const handleNameChange = ({ target: { value } }) => {
    if (!wasEdited) {
      setWasEdited(true);
    }

    setName(value);
    setNameError("");
  };

  const handleNameBlur = () => {
    if (name.trim() === "") {
      setNameError(BLANK_CATEGORY_NAME_ERROR);
    } else if (categories.some((category) => category.name === name)) {
      setNameError(CATEGORY_NAME_DUPLICATE_ERROR);
    }
  };

  const handleDescriptionChange = ({ target: { value } }) => {
    setDescription(value);
  };

  const handleCreateClick = () => {
    dispatch(createNewCategory(name, description, insertAt));
  };

  const handleCancelClick = () => {
    dispatch(hideModal(modalTypes.CREATE_NEW_CATEGORY));
  };

  return (
    <Modal
      show
      centered
      backdrop="static"
      data-test="create-new-category-modal"
      className="fade-in create_new_entry_modal"
      onDismiss={handleCancelClick}
    >
      <Modal.Header closeButton>
        <b>Create a new Category</b>
      </Modal.Header>
      <Modal.Body>
        <label htmlFor={nameId}>Category Name</label>
        <div className="create_new_entry_modal__name">
          <input
            type="text"
            id={nameId}
            autoFocus
            data-testid="name-input"
            value={name}
            onChange={handleNameChange}
            onBlur={handleNameBlur}
          />
          {nameError && (
            <IconWithTooltip
              icon={<ErrorIcon width={16} height={16} />}
              tooltipText={nameError}
            />
          )}
        </div>
        <label htmlFor={descriptionId}>Category Description</label>
        <textarea
          id={descriptionId}
          data-testid="description-input"
          rows={4}
          value={description}
          className="create_new_entry_modal__description"
          onChange={handleDescriptionChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <VTButton
          content="Create"
          variant={buttonVariants.primary}
          disabled={!wasEdited || nameError}
          onClick={handleCreateClick}
        />
        <VTButton
          content="Cancel"
          variant={buttonVariants.secondary}
          onClick={handleCancelClick}
        />
      </Modal.Footer>
    </Modal>
  );
};

CreateNewCategoryModal.propTypes = {
  insertAt: PropTypes.number.isRequired,
};

export default CreateNewCategoryModal;
